module.exports = __webpack_public_path__ + "images/category_lp/pc/PC2_b97821ab0d4d686fbc452ddab12e483e.png";